define 'controller/PagingController', ['jquery', 'lib/kryptonite'], ($) ->
  class PagingController

    constructor: (@$el) ->
      self = this
      $('.pager').on 'click',  '.pager__page, .pager__page--previous, .pager__page--next', (e) ->
        e.preventDefault()
        url = $(e.currentTarget).attr('href')
        unless history.pushState?
          window.location = url
          return
        history.pushState(null, null, url)
        self._loadAjax(url)

      # back-button-logic
      $(window).unbind 'popstate'
      $(window).bind 'popstate', (event) ->
        self._loadAjax(window.location.href)

    _loadAjax: (url) ->
      ajaxUrl = url + (if url.indexOf('?') == -1 then '?' else '&') + 'ajax=true'

      $.kryptonite
        url: ajaxUrl
        method: 'GET'
        beforeSend: ->
          $('html, body').animate({scrollTop: 224}, 1000)

    destroy: ->
      @$el.off()
      $('.pager').off 'click',  '.pager__page, .pager__page--previous, .pager__page--next'